/**
 * 描画行情報
 */
export class WprRowInfo {
	// private 変数  ------------------------------------------------------------
	private m_ListName: string	= null;		// リスト名
	private m_Index: number		= null;		// 行インデクス
	private m_RowData: any		= null;		// 行データ
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** リスト名 */
	public get listName(): string 	{ return this.m_ListName;	}
	/** 行インデクス */
	public get index(): number 		{ return this.m_Index;		}
	/** 行データ */
	public get rowData(): any 		{ return this.m_RowData;	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(listName: string, index: number, row: any) {
		this.m_ListName = listName;
		this.m_Index = index;
		this.m_RowData = row;
	}
	// --------------------------------------------------------------------------
}
